import axios from 'axios';

import { assertClientSide } from '@dr.pogodin/react-utils';

import type {
  GenericVideoUploadBodyT,
  GenericVideoUploadResT,
} from 'server/controllers/genericVideoController';

import { P_API_GENERIC_VIDEO, type VimeoVideoT, getConfig } from 'utils';

type GenericVideoUploadOptionsT = {
  file: File;

  name?: string;

  /**
   * Optional progress signals handler.
   * @param process Upload progress, a number within the [0, 1] range.
   */
  onProgress?: (progress: number) => void;
};

export async function genericVideoUpload({
  file,
  name,
  onProgress,
}: GenericVideoUploadOptionsT): Promise<VimeoVideoT> {
  assertClientSide();

  // eslint-disable-next-line import/dynamic-import-chunkname
  const { tusUpload } = await import('client/services/tus');

  const config = getConfig(true);

  const res = await axios.post<GenericVideoUploadResT>(P_API_GENERIC_VIDEO, {
    _csrf: config.CSRF,
    name,
    size: file.size,
  } satisfies GenericVideoUploadBodyT);

  await tusUpload({ data: file, onProgress, url: res.data.upload.upload_link });

  return res.data;
}
